import "core-js/stable";
import "regenerator-runtime/runtime";

/* eslint-disable */
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/blur-up/ls.blur-up';

import '../../styles/theme.scss';
// import'../../styles/style.scss.liquid';

import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';

// Theme JS
import aavyaTheme from '@aavya/theme';
window.aavyaTheme = aavyaTheme;

import quotes from '../modules/home-quotes';
import collection from '../modules/collection-sliders';
import productSlider from '../modules/product-sliders';
import quantity from '../modules/quantity';
// jQuery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import '../modules/accordion';
import tabs from '../modules/menu-tabs'
import shipping from '../modules/shipping';
import footerNav from '../modules/footer-nav';
import giftSlider from '../modules/gift';
import tabify from '../modules/tabify';
import tab from '../modules/tab';
import collections from '../modules/all-collections';
import Collection from '../modules/collection';
import ShopColor from '../modules/shopColor';
import homepageSlider from '../modules/homepage-slider';
import ADASupport from '../modules/adaSupport';

// Lazysizes config
lazySizesConfig.blurupMode = 'auto';

// Common a11y fixes
focusHash();
bindInPageLinks();
tabs();
shipping();
footerNav();
tabify();
tab();
Collection();
homepageSlider();

aavyaTheme({
    utilities: true,
    sidebar: true,
    slickSlider: true,
    instagram: false
});

ADASupport();
$(document).ready(function () {
    var wineGifts = document.getElementById('custom-gift-set');
    var growlerGifts = document.getElementById('growler-custom-gift-set');
    var margtiniGifts = document.getElementById('margtini-gift-set');

    if (wineGifts || growlerGifts || margtiniGifts) {
        giftSlider();
        window.giftSlider.init();
    }
    window.FooterNav.init();
    collections();
    quantity();
    quotes();
    collection();
    productSlider();

    window.tab.init();
    window.Collection.init();
    window.Tabs.init();
    window.tabi.init();
    CartJS.init(window.cartJSON, window.cartJSONConfig);
    document.getElementById('cartClose').onclick = function () {
        aavyaTheme.sidebar.close();
    };
    document.getElementById('menu-close').onclick = function () {
        aavyaTheme.sidebar.close();
    };
    $(document).on('cart.requestComplete', function () {
        aavyaTheme.sidebar.openRight();
        window.Shipping.update();
    });

    $('#submitButton').click(function () {
        fbq('track', 'Lead');
    });

    window.Shipping.update();
    $('.shopify-currency-form select').on('change', function () {
        $(this).parents('form').submit();
    });
    if (document.getElementById('shop-by-color')) {
        ShopColor();
        window.ShopColor.init();
    }

    $(document).on('keydown', function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode === 9) {
            $('body').addClass('tab-key');
        }
    });

    $(document).on('mousedown', function () {
        $('body').removeClass('tab-key');
    });

    $('.mega-menu__item .sub_links .active').each(function () {
        const cls = $(this).find('a').attr('data-target');
        $('.brand').each(function () {
            $(this).hide();
            if ($(this).hasClass(cls)) {
                $(this).show();
            }
        });
    });

    $('.mega-menu__item .sub_links li').on('mouseover', function () {
        $('.mega-menu__item .sub_links li').removeClass('active');
        $(this).addClass('active');
        const cls = $(this).find('a').attr('data-target');
        $('.brand').each(function () {
            $(this).hide();
            if ($(this).hasClass(cls)) {
                $(this).show();
            }
        });
    });

    $('.js-menu-expand, .js-acc-expand').on('click', function () {
        $(this).next().removeClass('collapsed');
        $(this).next().addClass('expanded');
        $('.js-menu-container').addClass('menu-open');
        $('.js-menu-container').scrollTop(0);
      })

      $('.js-back-level1, .acc-back-btn').on('click', function () {
        $(this).parent().removeClass('expanded');
        setTimeout(() => {
          $(this).parent().addClass('collapsed');
          $('.js-menu-container').removeClass('menu-open');
        }, 600)
      })

      $('.js-back-level2').on('click', function () {
          $(this).parent().removeClass('expanded');
          setTimeout(() => {
            $(this).parent().addClass('collapsed');
          }, 600)
      })
      $('.add-to-cart').on('click', function () {
        var incrementStep=$(this).data("incrementstep");
        CartJS.addItem($(this).data("variant-id"), incrementStep, {
            '_increment_step': '' + incrementStep
          });
      });
});
